import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { BaseQuestionPreviewComponent } from '../../../bases';
import { useQuestionContext } from '../../../core';
import { AnswerItem } from './components';
import { Checkbox } from 'antd';
import styled from '@xstyled/styled-components';
import { getSize } from '@lib/common';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledAnswerContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-top: ", ";\n"])), getSize('padding12'));
var StyledAnswerGroup = styled(Checkbox.Group)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  width: 100%;\n"])), getSize('padding12'));
var StyledQuestionTitle = styled.label(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 500;\n  color: #94a3b8;\n  line-height: 1rem;\n  text-transform: uppercase;\n"])));
export var MultipleChoicePreviewComponent = function MultipleChoicePreviewComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions;
  var multipleChoiceLabel = states.multipleChoiceLabel,
      readonly = states.readonly,
      isShowCorrectAnswer = states.isShowCorrectAnswer;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var _useState = useState([]),
      selectedAnswerIds = _useState[0],
      setSelectedAnswerIds = _useState[1];

  var multipleChoiceQuestion = question; // Fix: Handle case when correctAnswers is empty or undefined

  var correctAnswerIds = isShowCorrectAnswer ? (multipleChoiceQuestion.correctAnswers || []).map(function (correctAnswer) {
    return correctAnswer.answerId;
  }) : selectedAnswerIds;
  return /*#__PURE__*/_jsxs(BaseQuestionPreviewComponent, {
    states: states,
    actions: actions,
    children: [/*#__PURE__*/_jsx(StyledQuestionTitle, {
      children: multipleChoiceLabel.answers
    }), /*#__PURE__*/_jsx(StyledAnswerContainer, {
      children: /*#__PURE__*/_jsx(StyledAnswerGroup, {
        value: correctAnswerIds,
        onChange: function onChange(e) {
          return setSelectedAnswerIds(_toConsumableArray(e));
        },
        children: (multipleChoiceQuestion.answers || []).map(function (answer, index) {
          return /*#__PURE__*/_jsx(AnswerItem, {
            answer: answer,
            index: index,
            isCorrectAnswer: (multipleChoiceQuestion.correctAnswers || []).some(function (correctAnswer) {
              return correctAnswer.answerId === answer.id.toString();
            }),
            readonly: readonly,
            isShowCorrectAnswer: isShowCorrectAnswer,
            isSelected: selectedAnswerIds.includes(answer.id.toString())
          }, answer.id.toString());
        })
      })
    })]
  });
};